import {Injectable} from '@angular/core';
import { sha256 } from 'js-sha256';

@Injectable({
    providedIn: 'root'
})
export class HashService {
  getParametersHash(params: any): string {
    const str = JSON.stringify(params, Object.keys(params).sort());

    return this.sha256(str);
  }

  sha256(str:string){
    return sha256(str);
  }
}
